module.exports = __webpack_public_path__ + "img/poster4-desc.7b284ce5.png";